import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './App.css'; // Ensure this imports slick-carousel styles as well



const CoverImage = () => {
    const [gallery, setGallery] = useState([]);

 useEffect(() => {
    const hardCodedImages = [
    { imageData: "/images/coverpage2.webp", caption: "Make Your Travel Plan with Us" },
      { imageData: "/images/coverpage4.webp", caption: "Explore the Hidden Gems" },
      { imageData: "/images/coverpage3.webp", caption: "Your Journey Starts Here" },
      { imageData: "/images/coverpage7.webp", caption: "Explore the Hidden Gems" },
    ];
    setGallery(hardCodedImages);
  }, []);

    // Settings for the carousel
    const carouselSettings = {
        dots: true, // Enable dots for navigation
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 6000
    };

    return (
        <div className="cover-image">
            {gallery.length > 0 ? (
                <Slider {...carouselSettings}>
                    {gallery.map((image, index) => (
                        <div key={index} className="image-wrapper">
                            <img
                                src={image.imageData} // Directly using the image path
                                className="image-container img" // Class for the image styling

                            />
                            <div className="image-text">
                                              {image.caption}
                                            </div>
                        </div>
                    ))}
                </Slider>
            ) : (
                <p>No cover images available.</p>
            )}
        </div>
    );
};

export default CoverImage;


